<ng-content></ng-content>

<div class="spinner-grow" role="status">
  <span class="sr-only">Loading...</span>
</div>
